export default "/react/logoCraftum-d184930b.png";